import { Col, Modal, Row } from "antd";
import { useEffect, useState } from "react";
import moment from "moment";

const HistoryModal = (props) => {
    const [successfull_transactions, setSuccessfulTransactions] = useState(0)

    useEffect(() => {
        if (props.historyData) {
            setSuccessfulTransactions(props.historyData.length)
        }
    }, [props.historyData])

    const handleCancel = () => props.setHistoryModal(false);

    const historyModalHeader = () => (
        <div className="history-modal-header">
            <p>Payment History</p>
            <br />
            <span style={{ fontWeight: 100, fontSize: 14, position: "relative", top: -22 }}>
                <b style={{ fontWeight: 600 }}>
                    {successfull_transactions}
                </b>
                &nbsp;Successful Transactions
            </span>
        </div>
    )
    return (
        <Modal
            visible={props.isHistoryModal}
            className="history-modal"
            onCancel={handleCancel}
            width={600}
            title={historyModalHeader()}
            footer={null}
            style={{margin:"5% auto"}}
        >
            <div style={{overflowY:"auto", maxHeight:"365px"}}>
                {props.historyData.length > 0 ? props.historyData.map((row) => {
                    return <Row justify="center" className="map-row">
                        <Col xl={{ span: 10 }} lg={{ span: 10 }} xs={{ span: 24 }}>
                            <p style={{ margin: 0 }}><b>Amount &nbsp;:</b>&nbsp;&#8377;{row.paid_amount}</p>
                            <p style={{ color: "#2a2a2a", margin: "0" }}><b>Date :</b> {moment(row.created_date).format("lll")}</p>

                        </Col>
                        <Col xl={{ span: 12 }} lg={{ span: 12 }} xs={{ span: 24 }}>
                            <p style={{ margin: 0, color: "#2a2a2a", fontSize: "13px" }}><b>Payment Mode :</b> &nbsp;{row?.peb_transaction_info?.transaction_type}</p>
                            <p style={{ color: "#2a2a2a", fontSize: "13px", margin: "0" }}><b>Transaction ID &nbsp; :</b> &nbsp;{row?.peb_transaction_info?.peb_transaction_id}</p>
                        </Col>
                    </Row>
                }) :
                <div style={{ textAlign: "center" }}>
                    <img alt="" src="https://ebz-static.s3.ap-south-1.amazonaws.com/partial_payment/no-data.svg" />
                    <p>No Data Found</p>
                </div>
            } 
            </div>
        </Modal>
    )
}
export default HistoryModal;